import { render, staticRenderFns } from "./CoverYearCCRThreshold.vue?vue&type=template&id=445caab6"
import script from "./CoverYearCCRThreshold.vue?vue&type=script&lang=js"
export * from "./CoverYearCCRThreshold.vue?vue&type=script&lang=js"
import style0 from "./CoverYearCCRThreshold.vue?vue&type=style&index=0&id=445caab6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports